import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
const names = ['María G.', 'Carmen L.', 'Ana P.', 'Laura M.', 'Isabel R.', 'Elena S.', 'Marta C.', 'Lucía F.', 'Sofía B.', 'Rosa V.'];
const cities = ['Ciudad de México', 'Bogotá', 'Buenos Aires', 'Lima', 'Santiago', 'Madrid', 'Miami', 'Guadalajara', 'Medellín', 'Monterrey'];
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/k8FSEp1SzoVwTeG4gDD2ZD/SUENO_PROFUNDO.png';
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay before first popup
    const initialTimer = setTimeout(() => {
      showRandomBuyer();
    }, 5000);
    // Set up the recurring 20-second cycle
    const intervalTimer = setInterval(() => {
      showRandomBuyer();
    }, 20000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(intervalTimer);
    };
  }, []);
  const showRandomBuyer = () => {
    const randomName = names[Math.floor(Math.random() * names.length)];
    const randomCity = cities[Math.floor(Math.random() * cities.length)];
    setCurrentBuyer({
      name: randomName,
      city: randomCity
    });
    setIsVisible(true);
    // Auto-hide after 4 seconds
    setTimeout(() => {
      setIsVisible(false);
    }, 4000);
  };
  return <AnimatePresence data-id="element-139">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-4 left-4 z-50 max-w-xs w-full" data-id="element-140">
          <div className="glass-card rounded-xl p-3 pr-8 relative shadow-2xl border border-white/10 bg-navy-900/95 backdrop-blur-md flex items-center gap-3" data-id="element-141">
            <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-warmWhite-200/50 hover:text-warmWhite-100 transition-colors" aria-label="Cerrar notificación" data-id="element-142">
              <X className="w-4 h-4" data-id="element-143" />
            </button>

            <div className="w-12 h-16 shrink-0 rounded-md overflow-hidden bg-navy-800 flex items-center justify-center" data-id="element-144">
              <img src={PRODUCT_IMAGE} alt="El Protocolo de Sueño Profundo" className="w-full h-full object-cover" data-id="element-145" />
            </div>

            <div className="flex-1 min-w-0" data-id="element-146">
              <p className="text-xs text-warmWhite-200/70 truncate mb-0.5" data-id="element-147">
                <span className="font-semibold text-warmWhite-100" data-id="element-148">
                  {currentBuyer.name}
                </span>{' '}
                de {currentBuyer.city}
              </p>
              <p className="text-sm font-medium text-warmWhite-100 leading-tight mb-1" data-id="element-149">
                acaba de comprar El Protocolo de Sueño Profundo
              </p>
              <p className="text-xs font-bold text-gold-400" data-id="element-150">$9.36 USD</p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}